import DischargeDataListController from './discharge-data-list.controller';
import './discharge-data-list.css';

const template = require<string>('./discharge-data-list.html');

const dischargeDataListComponent:ng.IComponentOptions = {
  bindings: {
    measuredDischargeDataItems: '<',
    onCreatedItemsChange: '&',
    onSelectedItemsChange: '&'
  },
  controller: DischargeDataListController,
  require: {
    dischargeDataListCurveController: '^^?imomoDischargeDataListCurve'
  },
  template
};

export default dischargeDataListComponent;



/** WEBPACK FOOTER **
 ** ./app/discharge/data-list/discharge-data-list.component.ts
 **/